import script from "./SummaryReportXTSAssessment.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportXTSAssessment.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportXTSAssessment.vue?vue&type=style&index=0&id=27cb71d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cb71d2"]])

export default __exports__